<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">Home</a></li>
                            <li>Testes</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" v-canaccess="'/avaliacao/create'" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Testes</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label for="titulo">Título</label>
                                    <input type="text" class="form-control" name="titulo" placeholder="Titulo" v-model="filter.titulo" maxlength="150" />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="disciplinaId">Disciplina</label>
                                    <select v-select="{ dataitem: 'AuxDisciplina', default: 'Todos' }" v-model="filter.disciplinaId" class="form-control" name="disciplinaId"></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="cargoId">Cargo</label>
                                    <select v-select="{ dataitem: 'Cargo', default: 'Todos' }" v-model="filter.cargoId" class="form-control" name="cargoId"></select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="tagJobsId">Tags</label>
                                    <select v-select="{ dataitem: 'TagJobs', default: 'Todos' }" v-model="filter.tagJobsId" class="form-control" name="tagJobsId"></select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label>Ativo?</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.ehAtivo" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.ehAtivo" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehAtivo" v-model="filter.ehAtivo" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Título <i @click="executeOrderBy('Titulo')" class="fa fa-sort"></i></th>
                                    <th>Nota de Aprovação <i @click="executeOrderBy('NotaAprovacao')" class="fa fa-sort"></i></th>
                                    <th>Tempo Máximo <i @click="executeOrderBy('tempoMaximo')" class="fa fa-sort"></i></th>
                                    <th>Cargo <i @click="executeOrderBy('Cargo')" class="fa fa-sort"></i></th>
                                    <th>Ativo? <i @click="executeOrderBy('EhAtivo')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.titulo }}</td>
                                    <td>{{ item.notaAprovacao }}</td>
                                    <td>{{ item.tempoMaximo }}</td>
                                    <td style="text-overflow: ellipsis; white-space: nowrap; max-width: 30ch; overflow: hidden;">
                                        <span v-for="item2 in item.collectionAvaliacaoCargo" v-bind:key="item2.cargoId" class="animated fadeIn">
                                            {{ item2.cargo.nmCargo }}<br />
                                        </span>
                                    </td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ehAtivo, 'badge-danger': !item.ehAtivo }">{{item.ehAtivo ? 'Sim' : 'Não'}}</span></td>
                                    <td class="text-center" style="min-width:200px;">
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Disponibilidade" v-canaccess="'/avaliacao/edit'" @click="openAviso({ avaliacaoId: item.avaliacaoId, indisponivel: item.indisponivel, indisponivelObservacao: item.indisponivelObservacao})">
                                            <i v-if="item.indisponivel" class="fa fa-lock"></i>
                                            <i v-else="item.indisponivel" class="fa fa-unlock"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" v-canaccess="'/avaliacao/edit'" @click="openEdit({ avaliacaoId: item.avaliacaoId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button v-if="item.ehAtivo" type="button" class="btn btn-sm btn-warning" v-b-tooltip title="Visualizar" v-canaccess="'/avaliacao/edit'" @click="openVisualizarTeste({ avaliacaoId: item.avaliacaoId  })">
                                            <i class="fa fa-file-text-o"></i>
                                        </button>
                                        <button v-if="!item.ehAtivo" type="button" class="btn btn-sm btn-success" v-b-tooltip title="Ativar" v-canaccess="'/avaliacao/delete'" @click="openAtivar({ avaliacaoId: item.avaliacaoId })">
                                            <i class="fa fa-play"></i>
                                        </button>
                                        <button v-if="item.ehAtivo" type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Inativar" v-canaccess="'/avaliacao/delete'" @click="openInativar({ avaliacaoId: item.avaliacaoId })">
                                            <i class="fa fa-pause"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Remover" v-canaccess="'/avaliacao/delete'" @click="openRemove({ avaliacaoId: item.avaliacaoId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="avaliacaoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogVisualizar" :hide-footer="true" title="Visualização Provisória do Teste">
            <form-visualizar v-if="dialogVisualizar" :id="avaliacaoId" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este Teste?</p>
            <p>Caso o Teste a ser removido contenha itens atrelados ele será inativado.</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogAtivar" title="Confirmação">
            <p>Tem certeza que deseja Ativar este Teste?</p>
            <!--<p>Caso o Teste a ser removido contenha itens atrelados ele será inativado.</p>-->
            <div slot="modal-footer">
                <button class="btn btn-sm btn-success" @click="executeAtivar()">
                    Ativar
                </button>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogInativar" title="Confirmação">
            <p>Tem certeza que deseja inativar este Teste?</p>
            <!--<p>Caso o Teste a ser removido contenha itens atrelados ele será inativado.</p>-->
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeInativar()">
                    Inativar
                </button>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogAviso" title="Confirmação">
            <p>Tem certeza que deseja incluir o aviso de indisponibilidade?</p>

            <input type="text" class="form-control" name="IndisponivelObservacao" id="IndisponivelObservacao" placeholder="Observação" v-model="vIndisponivelObservacao" maxlength="500" />
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeAviso()">
                    Incluir
                </button>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogAviso1" title="Confirmação">
            <p>Tem certeza que deseja excluir o aviso de indisponibilidade?</p>

            <input type="text" class="form-control" name="IndisponivelObservacao1" readonly="readonly" id="IndisponivelObservacao1" placeholder="Observação" v-model="vIndisponivelObservacao1" />
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeAviso()">
                    Excluir
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    import formVisualizar from './form-visualizar'

    export default {
        name: 'avaliacao',
        mixins: [base],
        components: { formCreate, formEdit, formVisualizar },
        data() {
            return {
                vIndisponivelObservacao: '',    
                vIndisponivelObservacao1: '',    
                resources: {
                    filter: 'avaliacao',
                    remove: 'avaliacao',
                    aviso: 'avaliacao',
                    ativar: 'avaliacao',
                    inativar: 'avaliacao',

                },

                dialogRemove: false,
                dialogAtivar: false,
                dialogInativar: false,
                dialogAviso: false,
                dialogAviso1: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogVisualizar: false,                
                model: {
                   
                },
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                    attributeBehavior: "ListagemTestes",
                    ehExcluido:false,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.$router.push({ path: '/avaliacao/edit/' + model.avaliacaoId });
            },
            openAviso: function (model) {                
                this.avaliacaoId = model.avaliacaoId;

                if (!model.indisponivel) {
                    this.dialogAviso = true;                
                    this.dialogAviso1 = false;                
                    this.vIndisponivelObservacao = model.indisponivelObservacao;
                }
                else {
                    this.dialogAviso1 = true;                
                    this.dialogAviso = false;                
                    this.vIndisponivelObservacao1 = model.indisponivelObservacao;
                }
            },            
            openCreate: function () {
                this.$router.push({ path: '/avaliacao/create' });
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogVisualizar = false;
                this.dialogRemove = false;
                this.dialogInativar = false;
                this.dialogAtivar = false;
                this.dialogAviso = false;
                this.dialogAviso1 = false;
            },

            openVisualizarTeste: function (model) {
                this.avaliacaoId = model.avaliacaoId;
                this.dialogVisualizar = true;
               
            },
            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
                
            },
            openAtivar: function (model) {
                this.dialogAtivar = true;
                //console.log("model", model);
                //this.model.avaliacaoId = this.avaliacaoId;
                //this.avaliacaoId = model.avaliacaoId;
                //console.log("model2", this.avaliacaoId);
                this.model = model;
            },
            openInativar: function (model) {
                this.dialogInativar = true;
                //this.avaliacaoId = model.avaliacaoId;
                //this.model = model;
                //this.avaliacaoId = model.avaliacaoId;
                this.model = model;
                
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(data => {
                    this.defaultSuccessResult("Ação realizada com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            executeAtivar: function (model) {

                if (model) this.model = model;
                //console.log(this.avaliacaoId);               
                new Api("avaliacao/ativar").post(this.model).then(data => {
                    this.defaultSuccessResult("Ação realizada com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            executeInativar: function (model) {
                if (model) this.model = model;
                new Api("avaliacao/inativar").post(this.model).then(data => {
                    this.defaultSuccessResult("Ação realizada com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            executeAviso: function (model) {
                if (model)
                    this.model = model;

                new Api('avaliacao/aviso').get({
                    avaliacaoId: this.avaliacaoId,
                    indisponivelObservacao: this.vIndisponivelObservacao,
                }).then(data => {
                    this.defaultSuccessResult("Ação realizada com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },
            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    //console.log(data);

                    data.dataList = data.dataList.map(item => {
                        if (item.collectionAvaliacaoCargo)
                            item.collectionAvaliacaoCargo = item.collectionAvaliacaoCargo
                                .sort((a, b) => { return a.cargo.nmCargo > b.cargo.nmCargo });
                        return item;
                    });

                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();              
        }

    };
</script>